(function() {
	'use strict';

	if ( angular.isDefined( window.wpConstants.sentry_dsn ) ) {
		Raven
			.config(window.wpConstants.sentry_dsn, window.wpConstants.sentry_options)
			.addPlugin(Raven.Plugins.Angular)
			.install();
	} else {
		// Prevent crashes if sentry plugin is disabled by creating a empty
		// module with the same name
		angular.module( 'ngRaven', [] )
			.run(function () {
				console.warn( '!!! Sentry DSN is not set, error reporting is inactive' );
			});
	}
})();